import Commons from './Services/Common/Common.js';
import Global from './Services/Common/Global.js';
import Store from './Store/Store.js';
import { urlB64ToUint8Array } from './urlB64ToUint8Array.js';

// const serverUrl = `http://${window.location.hostname}:3000`;
const serverUrl = `https://v932ze2144.execute-api.ap-northeast-2.amazonaws.com`;

export const getPermission = () => {
  // Notification.requestPermission(function (status) {
  //   alert('Notification permission status:' + status);
  // });
  Notification.requestPermission().then((permission) => {
    // alert("Notification permission status:" + permission);
    // console.log("getPermission: ", permission);
  });
};

export const getSubscription = async () => {
  const { pubkey } = await fetch(`${serverUrl}/pubkey`).then((res) =>
    res.json()
  );
  alert('fetched public key:' + pubkey);
  console.log('getSubscription1: ', pubkey);
  const subscription = await navigator.serviceWorker
    .getRegistration()
    .then((registration) => {
      return registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlB64ToUint8Array(pubkey),
      });
    });
  alert('created subscription:' + JSON.stringify(subscription));
  console.log('getSubscription2: ', subscription);
  // in production we would send it directly to our server and not store it on the window
  window.mySubscription = subscription;
};

export const sendToServer = async () => {
  if (!window.mySubscription) {
    alert('No subscription yet created');
    return;
  }
  const subscription = JSON.stringify(window.mySubscription.toJSON(), null, 2);
  console.log('sendToServer: ', window.mySubscription.toJSON());
  fetch(`${serverUrl}/subscription`, {
    method: 'POST',
    body: subscription,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) => alert('successfully send subscription to server'))
    .catch((err) => alert('error while sending to server' + err));
};

export const sendMessageViaServer = async () => {
  const message = 'hihihi'; //document.getElementById('message').value;
  const body = JSON.stringify(
    { message, pushSubscription: window.mySubscription.toJSON() },
    null,
    2
  );
  console.log('sendMessageViaServer: ', window.mySubscription.toJSON());

  fetch(`${serverUrl}/send`, {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) =>
      alert('successfully send message via server to push service')
    )
    .catch((err) => alert('error while sending to server' + err));
};

export const displayNotificationDirectly = async () => {
  if (Notification.permission !== 'granted') {
    alert('notification permission missing');
    return;
  }

  const options = {
    body: 'This notification is send without a server, directly by the browser',
    icon: 'images/checkmark.png',
    vibrate: [100, 50, 100],
    data: {
      dateOfArrival: Date.now(),
      primaryKey: 1,
    },
    actions: [
      {
        action: 'explore',
        title: 'Explore this new world',
        icon: 'images/checkmark.png',
      },
      {
        action: 'close',
        title: 'Close notification',
        icon: 'images/xmark.png',
      },
    ],
  };

  const registration = await navigator.serviceWorker.getRegistration();
  registration.showNotification('Notification without Push API', options);
};

//
const isBlank = (v) => v == null || String(v).trim() === '';

// 스키마 기반 초기값 세팅
export const createInitial = (schemaField) => {
  const initial = {};
  const fields = schemaField?.fields || schemaField || {};

  for (const key in fields) {
    initial[key] = fields[key]?.initial;
  }

  return initial;
};

const isRequiredByWhen = (meta, userInfo, row) => {
  const when = meta?.requiredWhen;

  if (!when) return true;

  if (when === 'ADMIN') return userInfo?.authCd === 'ADMIN';

  if (typeof when === 'function') return !!when({ userInfo, row });

  return true;
};

//스키마 기반 필수값 검증
export const validateRequired = (rows, schema) => {
  const userInfo = Store.getState()?.BaseInfo?.userInfo;
  const fields = schema?.fields || {};
  const list = rows || [];

  for (const field in fields) {
    const meta = fields[field];
    if (meta?.required !== 'Y') continue;

    const invalid = list.some((r) => {
      if (!isRequiredByWhen(meta, userInfo, r)) return false;
      return isBlank(r?.[field]);
    });

    if (invalid) {
      const label = meta?.label || field;
      return { valid: false, field, message: `${label}은(는) 필수입니다.` };
    }
  }

  return { valid: true };
};

// 스키마 기반으로 payload 생성
export const mapRowsBySchema = (rows = [], mapper = {}, context = {}) => {
  const list = rows ?? [];
  const result = [];

  const userInfo = context.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
  const search = context.search ?? Store.getState()?.SearchInfo;
  const ctx = {
    ...context,
    ...(userInfo ? { userInfo } : {}),
    ...(search ? { search } : {}),
  };

  for (let i = 0; i < list.length; i++) {
    const row = list[i];
    const payload = {};

    for (const key in mapper) {
      const fn = mapper[key];
      payload[key] = typeof fn === 'function' ? fn(row, ctx) : fn;
    }
    result.push(payload);
  }

  return result;
};

// 스키마 기반으로 단일 payload 생성
export const mapParamsBySchema = (mapper = {}, context = {}) => {
  const userInfo = context.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
  const search = context.search ?? Store.getState()?.SearchInfo;
  const ctx = {
    ...context,
    ...(userInfo ? { userInfo } : {}),
    ...(search ? { search } : {}),
  };

  const payload = {};
  for (const key in mapper) {
    const fn = mapper[key];
    payload[key] = typeof fn === 'function' ? fn(null, ctx) : fn;
  }
  return payload;
};

// 파일 미리보기용 src 생성
export const toPreviewSrc = (value) => {
  if (!value || typeof value !== 'string') return '';

  if (value.startsWith('data:image')) return value;

  if (value.startsWith('http://') || value.startsWith('https://')) return value;

  return Global.file.useUrl + 'files/' + Commons.EncodeUrl(value);
};
